import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE_AMOUNT, PRICE_CURRENCY } from '../data/content';
const recap = ['6 Volumes', '5 Bonuses', '240 Main-Volume Pages', 'A Full Year of Salsa & Bachata Teaching'];
const reassurances = ['Instant digital download', 'Printable PDFs', '7-day satisfaction guarantee'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="1jclii55l19os">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1eek1rqvmpmgh" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1t1wsdu0amidq">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1o43ml22wjqdz">
          Your Salsa &amp; Bachata Classes Can Be <em className="text-red-700" data-id="element-118" data-mp="2245y86km9nks">Ready Today.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="1x5b78hchwspl">
          Instead of searching for drills, creating every exercise yourself, and spending Sunday
          evenings planning, have an organised salsa &amp; bachata teaching bundle for the whole year. More time
          for what matters:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="x2h2geg13scz">
          Your Students. Your Teaching. Your Life Outside the Studio.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="163p0cvemur6j">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b1guzx6nwref">{item}</li>)}
        </ul>

        <p className="mt-8 whitespace-nowrap font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1fvb8givoca52">
          {PRICE_AMOUNT}
          <span className="ml-2 text-2xl tracking-normal text-slate-900/70 sm:text-3xl" data-id="element-124" data-mp="1kvftmm7j1t1m">{PRICE_CURRENCY}</span>
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-125" data-mp="1ttrpp3r5xj1g">One-time payment — no subscription.</p>

        <div className="mt-8 flex justify-center" data-id="element-126" data-mp="3quoxkvn10vpe">
          <CtaButton className="w-full sm:w-auto" data-id="element-127" data-mp="3qv70uc83wa6t" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-128" data-mp="3lw44rha3teaz">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-129" data-mp="3iedwcuntbwv">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-130" data-mp="3uvqw1a94d3qb" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}